// assets
import { ChromeOutlined, QuestionOutlined } from '@ant-design/icons';

// icons
const icons = {
  ChromeOutlined,
  QuestionOutlined
};

// ==============================|| MENU ITEMS - SAMPLE PAGE & DOCUMENTATION ||============================== //

const support = {
  id: 'support',
  title: 'FCRA',
  type: 'group',
  children: [
    {
      id: 'documentation',
      title: 'Fair Credit Reporting Act',
      type: 'item',
      url: 'https://www.ftc.gov/legal-library/browse/statutes/fair-credit-reporting-act',
      icon: icons.QuestionOutlined,
      external: true,
      target: true
    }
  ]
};

export default support;
